module.exports = __webpack_public_path__ + "static/media/Factory Design Utilities.6b9eea31.png";